import UtilService from '../services/util';
import {
  statusOptions,
  intakes,
  financeStatuses,
  paymentStatuses,
  referalLocations,
} from '../models/static';
import StudentService from '../services/student.service';

const initialState = {
  filter: {
    messages: null,
    time: null,
    booking: null,
    status: null,
    english_test: null,
    interview: null,
    admins: null,
    university: null,
    address: null,
    moderator: null,
    course: null,
    student: null,
    intake: null,
    teamLeaderOnly: false,
    urgentApps: false,
    studentId: null,
    previous: null,
    timetable: [],
    teams: null,
    studentFormStatus: null,
    upfrontStatus: null,
    finalStatus: null,
    needsScreenShootApproval: false,
    needsApproval: false,
    deletedAgents: false,
    acceptedMarketing: false,
  },
  intakes: [],
  filterOptions: {},
  isFilterLoading: true,
  fullyLoaded: false,
  filterPerPage: localStorage.getItem('appPagination')
    ? localStorage.getItem('appPagination')
    : 50,
};

export const application_filter = {
  namespaced: true,
  state: initialState,
  actions: {
    setInitialFilters({ commit }, data) {
      commit('setInitialFilters', data);
    },

    storeFetchIntakes({ commit }) {
      StudentService.fetchIntakes().then((response) => {
        commit('setIntakes', response.data);
        return Promise.resolve();
      });
    },

    addUniversityFilter({ commit }, data) {
      commit('addUniversityFilter', data);
    },

    addCustomTag({ commit }, data) {
      commit('addCustomTag', data);
    },

    setFilterData({ commit }, data) {
      commit('setFilterData', data);
    },

    resetFilterData({ commit }) {
      commit('resetFilterData');
    },

    setFilterPerPage({ commit }, data) {
      commit('setFilterPerPage', data);
    },
  },
  mutations: {
    setInitialFilters(state, response) {
      const applications = response.apps;
      const universities = response.universities;
      const mappedUniWithAdmins = universities
        .map((uni) => {
          return uni.university_admins.map((admin) => {
            return {
              username: admin.user ? admin.user.username : 'None',
              id: admin.user.id,
              uniId: admin.universityId,
            };
          });
        })
        .flat(1);

      state.filterOptions = {
        booking: UtilService.generateFilterArray([
          'None',
          ...applications.map(
            (application) => application.studentData.generalInfo.booking
          ),
        ]),
        english_test: UtilService.generateFilterArray([
          'None',
          'Today',
          'Tomorrow',
          'This week',
          'Custom',
          ...applications.map(
            (application) => application.studentData.generalInfo.english_test
          ),
        ]),
        interview: UtilService.generateFilterArray([
          'None',
          'Today',
          'Tomorrow',
          'This week',
          'Custom',
          ...applications.map(
            (application) => application.studentData.generalInfo.interview
          ),
        ]),
        admins: UtilService.generateFilterArray([
          ...universities
            .map((uni) => {
              return uni.university_admins.map((admin) => admin.user.username);
            })
            .flat(1),
        ]),
        adminsWithUni:
          UtilService.getUniqueUsersWithUniIDs(mappedUniWithAdmins),
        moderator: UtilService.generateFilterArray([
          ...applications.map((application) => application.moderator),
        ]),
        course: UtilService.generateFilterArray([
          ...applications.map((application) => application.courseTitle),
        ]),
        student: UtilService.generateFilterArray([
          ...applications.map(
            (application) =>
              application.studentData.personalInformation.student_name
          ),
        ]),
        studentIds: UtilService.generateFilterArray([
          'None',
          ...applications.map(
            (application) => application.studentData.generalInfo.studentId
          ),
        ]),
        status: UtilService.generateFilterArray([
          'All',
          'None',
          ...statusOptions,
          ...applications.map((application) => application.status),
        ]),
        intake: state.filterOptions.intake,
        sfe: UtilService.generateFilterArray([
          'None',
          ...applications.map(
            (application) => application.studentData.generalInfo.student_finance
          ),
        ]),
        student_referal: UtilService.generateFilterArray(referalLocations),
        timetable: ['day', 'evening', 'weekend', 'blended'],
        universities,
        studentFormStatus: UtilService.generateFilterArray(financeStatuses),
        upfrontStatus: UtilService.generateFilterArray(paymentStatuses),
        finalStatus: UtilService.generateFilterArray(paymentStatuses),
        teams: UtilService.getTeamLeadersApplications()
          .map((userData) => {
            if (userData.user.isTeamLeader) {
              return {
                userId: userData.userId,
                teamId: userData.teamId,
                teamName: userData.team.name,
                username:
                  userData && userData.user ? userData.user.username : 'None',
              };
            }

            return null;
          })
          .filter(Boolean),
      };
      state.isFilterLoading = false;
      state.fullyLoaded = response.finishedLoading;
    },

    setIntakes(state, data) {
      const intakeData = data.length
        ? data.map((intake) => intake.name)
        : intakes;

      state.intakes = data;

      state.filterOptions.intake = UtilService.generateFilterArray([
        ...intakeData,
        'None',
      ]);
    },

    setFilterPerPage(state, data) {
      if (data) {
        state.filterPerPage = data;
        localStorage.setItem('appPagination', data);
      }
    },

    resetFilterData(state) {
      state.filter = {
        ...Object.keys(state.filter).forEach((k) => (state.filter[k] = null)),
      };
      state.filter.timetable = [];
    },

    setFilterData(state, data) {
      state.filter = UtilService.deepCopy(data);
    },

    addUniversityFilter(state, value) {
      state.filterOptions.universities = state.filterOptions.universities
        ? state.filterOptions.universities.concat(value)
        : [].concat(value);
      const filterCopy = UtilService.deepCopy(state.filter);

      state.filter = {
        ...filterCopy,
        address:
          value.type === 'address'
            ? filterCopy.address
              ? [...filterCopy.address].concat(value)
              : [].concat(value)
            : filterCopy.address,
        university:
          value.type === 'title'
            ? filterCopy.university
              ? [...filterCopy.university].concat(value)
              : [].concat(value)
            : filterCopy.university,
      };
    },

    addCustomTag(state, sentVlaue) {
      const value = sentVlaue.value;
      state.filterOptions[sentVlaue.type] = state.filterOptions[sentVlaue.type]
        ? state.filterOptions[sentVlaue.type].concat({
            value,
          })
        : [].concat({
            value,
          });

      const filterCopy = UtilService.deepCopy(state.filter);

      state.filter = {
        ...filterCopy,
        [sentVlaue.type]: filterCopy[sentVlaue.type]
          ? filterCopy[sentVlaue.type].concat({
              value,
            })
          : [].concat({
              value,
            }),
        // address: value.type === 'address' ? filterCopy.address ? [...filterCopy.address].concat(value) : [].concat(value) : filterCopy.address,
        // university: value.type === 'title' ? filterCopy.university ? [...filterCopy.university].concat(value) : [].concat(value) : filterCopy.university
      };
    },
  },
};
